import { initializeApp } from '@firebase/app';
import { getAnalytics, logEvent, setUserId } from '@firebase/analytics';

import { FIREBASE_ANALYTICS_MEASUREMENT } from 'services/constants';

const firebaseConfig = {
  apiKey: 'AIzaSyCQzVJgUxlpP0_gdfn7QKbMpaNO69ZU0J8',
  authDomain: 'rely-bb5a7.firebaseapp.com',
  databaseURL: 'https://rely-bb5a7.firebaseio.com',
  projectId: 'rely-bb5a7',
  storageBucket: 'rely-bb5a7.appspot.com',
  messagingSenderId: '19162348773',
  appId: '1:19162348773:web:9a180b09ce3096061d280c',
  ...(FIREBASE_ANALYTICS_MEASUREMENT ? { measurementId: FIREBASE_ANALYTICS_MEASUREMENT } : {}),
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const reduxBeaconFirebaseTarget = events => {
  events.forEach(event => {
    if (event.userId) {
      setUserId(analytics, event.userId);
    }
    if (event.type === 'page') {
      logEvent(analytics, 'screen_view', {
        firebase_screen: event.path,
        firebase_screen_class: event.path,
        companyId: event.dimension1,
        channelId: event.dimension2,
      });
      logEvent(analytics, 'screen_view_event', {
        companyId: event.dimension1,
        channelId: event.dimension2,
      });
    } else if (event.type === 'event') {
      logEvent(analytics, event.action, {
        companyId: event.dimension1,
        channelId: event.dimension2,
        messageType: event.dimension3,
      });
    }
  });
};

export default reduxBeaconFirebaseTarget;
